import { forwardRef } from 'react'
import { TextInput } from '@carbon/react'
import type { TextInputProps } from '@carbon/react'
import type { FormInputProps } from './types'
import { narrowToStringOrNumber } from './utils'
import { FormFieldLabel } from './FormFieldLabel'
import styles from './FormField.module.scss'

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  (
    {
      label,
      error,
      required,
      hint,
      className = '',
      defaultValue,
      value,
      onClick,
      size,
      ...props
    },
    ref
  ) => {
    const fieldId = props.id || props.name || `input-${Math.random()}`

    const carbonSize = ['sm', 'md', 'lg', 'xl'].includes(String(size))
      ? (size as unknown as TextInputProps['size'])
      : undefined

    const textInputProps: TextInputProps = {
      ...props,
      defaultValue: narrowToStringOrNumber(defaultValue),
      value: narrowToStringOrNumber(value),
      size: carbonSize,
      id: fieldId,
      labelText: <FormFieldLabel label={label} required={required} />,
      invalid: !!error,
      invalidText: error,
      helperText: hint && !error ? hint : undefined,
      ...(onClick && { onClick: onClick as TextInputProps['onClick'] }),
    }

    return (
      <div className={`${styles.wrapper} ${className}`}>
        <div className={styles.fieldWrapper}>
          <TextInput ref={ref} {...textInputProps} />
        </div>
      </div>
    )
  }
)

FormInput.displayName = 'FormInput'
